import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import '../css/CartPage.css';
import ProductList from './ProductList';

const CartPage = () => {
  const [cart, setCart] = useState(null);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      setError('Please login to see your cart.');
      return;
    }

    axios.get(`${process.env.REACT_APP_API_URL}/api/cart/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then(response => {
      setCart(response.data);
    })
    .catch(err => {
      console.error('Failed to load cart:', err);
      setError('Failed to load cart.');
    });
  }, []);

  const updateQuantity = (productId, action, quantity) => {
    const token = localStorage.getItem('token');
    axios.post(`${process.env.REACT_APP_API_URL}/api/cart/add`, null, {
      params: { productId, action, quantity },
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      setCart(response.data);
    })
    .catch(err => {
      console.error('Failed to update quantity:', err);
    });
  };

  const deleteCartItem = (cartItemId) => {
    const token = localStorage.getItem('token');
    axios.delete(`${process.env.REACT_APP_API_URL}/api/cart/${cartItemId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then(response => {
      console.log('Entity deleted successfully');
      const updatedCart = { ...cart, items: cart.items.filter(item => item.id !== cartItemId) };
      
      const updatedTotalPrice = updatedCart.items.reduce((acc, item) => {
        const discountedPrice = item.product.price - (item.product.price * item.product.discount) / 100;
        return acc + (discountedPrice * item.quantity);
      }, 0);

      updatedCart.totalPrice = updatedTotalPrice;
      setCart(updatedCart);
    })
    .catch(err => {
      console.error('Failed to delete cart item:', err);
      setError('Failed to delete the item.');
    });
  };

  const handleCheckout = () => {
    navigate('/addressSelection');
  };

  if (error) {
    return <div className="error-box">{error}</div>;
  }

  if (!cart) {
    return <div>Loading cart...</div>;
  }

  return (
    <div>
    <div className="cart-container">
      <h2>Your Shopping Cart</h2>

      {cart.items.length === 0 ? (
        <p>Your cart is empty.</p>
      ) : (
        <div className="cart-items">
          {cart.items.map(item => {
            const discountedPrice = (
              item.product.price - (item.product.price * item.product.discount) / 100
            ).toFixed(2);
            const subtotal = (discountedPrice * item.quantity).toFixed(2);

            return (
              <div key={item.id} className="cart-item">
                <img
                  src={`/uploads/${item.product.images[0]?.imageUrl}`}
                  alt={item.product.name}
                  className="cart-item-image"
                />
                <div className="cart-item-details">
                  <h3>{item.product.name}</h3>
                  <p>
                    <span className="original-price">₹{item.product.price.toFixed(2)}</span>
                    <span className="discounted-price"> ₹{discountedPrice}</span>
                    {item.product.discount > 0 && <span className="discount-text"> ({item.product.discount}% off)</span>}
                  </p>
                  <p>
                    <strong>Subtotal:</strong> ₹{subtotal}
                  </p>
                  <div className="quantity-controls">
                    <button
                      onClick={() => updateQuantity(item.product.id, 'decrease', 1)}
                    >
                      -
                    </button>
                    <span>{item.quantity}</span>
                    <button
                      onClick={() => updateQuantity(item.product.id, 'increase', 1)}
                    >
                      +
                    </button>
                  </div>
                  <button
                    className="delete-btn"
                    onClick={() => deleteCartItem(item.id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      <div className="cart-summary">
        <h3>Total: ₹{cart.totalPrice.toFixed(2)}</h3>
        <button onClick={handleCheckout} className="checkout-btn" 
        disabled={cart.items.length === 0}>Proceed to Checkout</button>
      </div>
      
    </div>
    <ProductList />
    </div>
  );
};

export default CartPage;
